import { Button, DatePicker, Form, Modal, Select } from "antd";
import Title from "antd/es/typography/Title";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
const { RangePicker } = DatePicker;

const INITIAL_OBJECT = {
  logType: "",
  user: "",
  startDate: "",
  endDate: "",
};

export const LogsFilter = ({
  open,
  setOpen,
  userList,
  filterDataFun,
  filterElements,
}) => {
  const [form] = Form.useForm();
  const [inputElements, setInputElements] = useState(INITIAL_OBJECT);

  const onFinish = (values) => {
    let startDate = "";
    let endDate = "";
    if (values?.dateRange?.length > 0) {
      startDate = `${values.dateRange[0].$y}-${
        values.dateRange[0].$M + 1 < 10
          ? "0" + (values.dateRange[0].$M + 1)
          : values.dateRange[0].$M + 1
      }-${
        values.dateRange[0].$D < 10
          ? "0" + values.dateRange[0].$D
          : values.dateRange[0].$D
      } 00:00:00`;

      endDate = `${values.dateRange[1].$y}-${
        values.dateRange[1].$M + 1 < 10
          ? "0" + (values.dateRange[1].$M + 1)
          : values.dateRange[1].$M + 1
      }-${
        values.dateRange[1].$D < 10
          ? "0" + values.dateRange[1].$D
          : values.dateRange[1].$D
      } ${values.dateRange[1].$H}:${values.dateRange[1].$m}:${
        values.dateRange[1].$s
      }`;
    }

    const bodyData = {
      log_type: inputElements.logType,
      user: values.user,
      start_date: startDate,
      end_date: endDate,
    };
    setInputElements((prev) => ({
      ...prev,
      user: bodyData.user,
      startDate: bodyData.start_date,
      endDate: bodyData.end_date,
    }));
    filterDataFun(bodyData, true);
  };

  function cancelFun() {
    const data = {
      log_type: inputElements.logType,
      user: "",
      start_date: "",
      end_date: "",
    };
    filterDataFun(data, true);
    setInputElements(INITIAL_OBJECT);
    form.resetFields();
  }

  function backFun() {
    setOpen(false);
  }

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        user: filterElements.user,
        dateRange:
          filterElements.startDate !== "" && filterElements.endDate !== ""
            ? [
                dayjs(filterElements.startDate.slice(0, 10), "YYYY-MM-DD"),
                dayjs(filterElements.endDate.slice(0, 10), "YYYY-MM-DD"),
              ]
            : [],
      });

      setInputElements({
        user: filterElements.user,
        logType: filterElements.logType,
        startDate: filterElements.startDate,
        endDate: filterElements.endDate,
      });
    }
  }, [open]);

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      footer={[]}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>Filters</Title>
        </div>
        <Form
          form={form}
          name="normal_login"
          className="logfilter-form"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item name="user" label="Select User">
            <Select
              name="user"
              style={{
                background: "#EBEEF8",
                fontSize: "13px",
                display: "block",
              }}
              options={userList.map((ele) => ({ value: ele, label: ele }))}
            />
          </Form.Item>
          <Form.Item name="dateRange" label="Select Date Range">
            <RangePicker
              allowClear={false}
              style={{ width: "100%" }}
              name="dateRange"
            />
          </Form.Item>
          <Form.Item style={{ marginTop: "10px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                key="clear"
                type="default"
                htmlType="reset"
                onClick={cancelFun}
                style={{ marginRight: "10px" }}
              >
                Clear All
              </Button>
              <Button key="submit" type="primary" htmlType="submit">
                Apply
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};
